import { useRef, useContext, createContext } from 'react';
import { subscribeWithSelector } from 'zustand/middleware';
import { shallow } from 'zustand/shallow';
import { useStoreWithEqualityFn, createWithEqualityFn } from 'zustand/traditional';

const StoreContext = createContext();

function createFlowFilterStore(set) {
  return {
    filterValue: '',
    chipDeviceId: null,
    chipMoodId: null,

    setFilterValue(filterValue) {
      set({ filterValue });
    },

    setChipDeviceId(chipDeviceId) {
      set({ chipDeviceId });
    },

    setChipMoodId(chipMoodId) {
      set({ chipMoodId });
    },

    clearFilter() {
      set({ filterValue: '', chipDeviceId: null, chipMoodId: null });
    },
  };
}

export function FlowFilterContext(props) {
  const storeRef = useRef(null);

  if (storeRef.current == null) {
    storeRef.current = createWithEqualityFn(subscribeWithSelector(createFlowFilterStore), shallow);
  }

  return <StoreContext.Provider value={storeRef.current}>{props.children}</StoreContext.Provider>;
}

function selectFlowFilter(state) {
  return state;
}

export function useFlowFilter(selector = selectFlowFilter) {
  const store = useContext(StoreContext);
  return useStoreWithEqualityFn(store, selector, shallow);
}
